import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

const Blank: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Box paddingY="s48" paddingX="s24" alignItems="center">
    <Text.Normal>{children}</Text.Normal>
  </Box>
)

export default Blank
